import React from 'react';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import { LuWatch } from 'react-icons/lu';
import { NavLink } from 'react-router-dom';

export default function TestPayment() {
	return (
		<main className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<div className="block w-100 flex-row mt-5 pb-20">
				<div className="flex mt-30 space-x-80">
					<h1 className="text-3xl font-bold text-gray-700 w-full sm:w-8/12">
						Test Payment
					</h1>
					{/* <div className=" flex">
                        <div><MdOutlineEditNote size="22" className="text-gray-400"/></div>
                        <p className="text-xs text-gray-500 ml-0.5 mt-1">Suggest Edits</p>
                    </div> */}
				</div>

				<div className="border-t border-gray-300 my-10 w-full sm:w-8/12"></div>

				<div id="cards" className="block mt-300">
					<h3 className="text-xl text-gray-700 font-semibold w-5/12">Cards</h3>
					<h6 className="text-sm text-gray-700 mt-2">
						These cards are for test purposes only, and will be used to test
						accept payments check-out.
					</h6>
				</div>

				<div className="w-full sm:w-8/12 sm:h-auto border-l-2 border-red-500 bg-red-50 mt-7 bg-opacity-60 p-4 flex flex-col sm:flex-row">
					<div className="text-red-600 -mt-1 text-4xl sm:text-5xl">!</div>
					<div className="pl-3 sm:pl-6">
						<p className="text-base font-semibold text-red-600 sm:text-xl">
							Don&apos;t give Value
						</p>
						<p className="text-sm mt-2 sm:mt-0 text-gray-700">
							Do not give value on the test environment because the payment will
							not be settled to your account.
						</p>
					</div>
				</div>

				<div className="block w-full sm:w-8/12 pt-4 flex flex-col items-center">
					<div className="text-center">
						<img src={require("../../assets/spayverve.png")} alt="overview" width={500} height={277} />
					</div>

					<div className="pt-2 text-center">
						<img src={require("../../assets/spayvisa.png")} alt="overview" width={500} height={277} />
					</div>
				</div>

				<div className="border-t border-gray-300 w-full sm:w-8/12 my-10"></div>

				<div className="flex pb-4 w-full sm:w-8/12 justify-between">
					<NavLink to="/response-code">
						<div className="flex">
							<div className="sm:mt-1 mt-2">
								<MdArrowBack size={16} color="gray" />
							</div>
							<p className="sm:text-base ml-2 sm:mt-0 mt-2 sm:font-medium text-xs text-gray-600">
								Response Code
							</p>
						</div>
					</NavLink>
					<NavLink to="/subscription">
						<div className="flex content-end">
							<p className="sm:text-base sm:mt-0 mt-2 text-xs mr-2 sm:font-medium text-gray-600">
								Subscription
							</p>
							<div className="sm:mt-1 mt-2">
								<MdArrowForward size={16} color="gray" />
							</div>
						</div>
					</NavLink>
				</div>

				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<div className="mb-2">
							<h3>Table of Contents</h3>
						</div>
						<div className="">
							<a href="#cards">
								<p className="text-sm">Cards</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}
